module.exports = __webpack_public_path__ + "media/components/assets/img/bg/airplane-a3b0bee3bee531e7585229a71de97ce6.svg";